import React, { FC } from 'react'
import styled from 'styled-components'
import { TypographyProps } from './props/typographyProps'

// Styled component for the divider
const DividerContainer = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    width: 100%;

    &::before,
    &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #ccc;
    }

    &::before {
        margin-right: 10px;
    }

    &::after {
        margin-left: 10px;
    }
`

const DividerText = styled.span`
    font-weight: bold;
    color: #333;
`

export const LabelWithHorizontalDivider: FC<TypographyProps> = ({
    text,
    className,
}) => {
    return (
        <DividerContainer className={className}>
            <DividerText>{text}</DividerText>
        </DividerContainer>
    )
}
